import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryProvider } from './providers/QueryProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { AuthProvider } from './providers/AuthProvider';
import { SystemGate } from './providers/SystemGate';
import { GlobalErrorBoundary } from './components/GlobalErrorBoundary';
import { router } from './routes';
import { useVisualViewportVars } from './hooks/useVisualViewportVars';

function ViewportSync() {
  useVisualViewportVars();
  return null;
}

export function App() {
  useEffect(() => {
    sessionStorage.removeItem('rm-chunk-reload');
  }, []);

  return (
    <GlobalErrorBoundary>
      <QueryProvider>
        <ThemeProvider>
          <SystemGate>
            <AuthProvider>
              <ViewportSync />
              <RouterProvider router={router} />
            </AuthProvider>
          </SystemGate>
        </ThemeProvider>
      </QueryProvider>
    </GlobalErrorBoundary>
  );
}
